<template>
  <div class="register absolute">
    <div class="info">
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
      <div class="cusInfo box">
        <p>用户名</p>
        <p>{{ userInfo.customer.nickname }}</p>
      </div>
    </div>
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="userInfo.user.avatar" v-if="userInfo.user.avatar" />
        <img src="@assets/images/logo2.png" v-else />
      </div>
      <p class="cus-name">
        <span>{{ userInfo.user.nickname }}</span>
      </p>
    </div>
    <p class="btnBox" v-if="!isBind">
      <button @click="bindCustomer">绑定此微信</button>
    </p>
  </div>
</template>
<script>
import { bindCustomer, getCustomerInfo } from "@api/order";

export default {
  name: "bind_customer",
  data: function() {
    return {
      id: "",
      userInfo: {},
      isBind: false
    };
  },
  mounted: function() {
    let id = this.$route.params.id;
    this.id = id;
    this.getCustomerInfo();
  },
  methods: {
    async submit() {},
    getCustomerInfo() {
      getCustomerInfo(this.id).then(res => {
        this.userInfo = res.data;
      });
    },
    bindCustomer() {
      bindCustomer(this.id)
        .then(res => {
          this.$dialog.toast({ mes: "绑定申请成功，等待后台审核" });
          this.isBind = true;
        })
        .catch(err => {
          this.$dialog.toast({ mes: err.msg });
        });
    }
  }
};
</script>
<style scoped>
.info {
  background: #f9c64d;
  padding-bottom: 0.2rem;
}
.box {
  margin: 0.2rem 0.5rem 0.1rem;
  border: 1px solid #f9c64d;
  border-radius: 0.1rem;
  overflow: hidden;
  /* box-shadow: #cccccc; */
}
.box p {
  /* height: 0.6rem; */
  line-height: 0.6rem;
  padding: 0 0.2rem;
  box-sizing: border-box;
}
.box p:nth-child(1) {
  background: #f99825;
  text-align: center;
  color: white;
}
.box p:nth-child(2) {
  background: #fbdf9b;
}
.code img {
  width: 100%;
  height: 100%;
}
.cus-name {
  text-align: center;
  margin-top: 0.2rem;
}
.cus-name span {
  background: #fad09f;
  border-radius: 5px;
  overflow: hidden;
  padding: 0.1rem 0.2rem;
  box-sizing: border-box;
  color: #eb431a;
}
.btnBox {
  padding: 0.9rem 0.2rem;
}
.btnBox button {
  width: 100%;
  color: #e94a30;
  font-size: 0.4rem;
  padding: 0.1rem 0;
  border-radius: 0.1rem;
  background: linear-gradient(#dac65a, #f39a38);
}
</style>
